import { KeywordCompetitorMapping } from '../../../modules/mpsSeo/reducer'

export const getIsSaveDisabled = (
  index: number,
  allKeywordCompetitorList: KeywordCompetitorMapping[],
  newKeywordCompetitorList: KeywordCompetitorMapping
) => {
  if (
    !allKeywordCompetitorList?.length ||
    allKeywordCompetitorList?.length < index + 1
  ) {
    return false
  }

  if (
    !newKeywordCompetitorList?.competitors?.length ||
    !newKeywordCompetitorList?.keywords?.length
  ) {
    return false
  }

  const currentObject = allKeywordCompetitorList[index]

  if (
    newKeywordCompetitorList?.competitors?.length !==
      currentObject?.competitors?.length ||
    newKeywordCompetitorList?.keywords?.length !==
      currentObject?.keywords?.length
  ) {
    return false
  }

  const oldCompetitorsIds = currentObject?.competitors?.map(item => item?._id)
  const isChangeInCompetitor = newKeywordCompetitorList?.competitors?.filter(
    item => !oldCompetitorsIds.includes(item._id)
  )

  const oldKeywordsIds = currentObject?.keywords?.map(item => item?._id)
  const isChangeInKeywords = newKeywordCompetitorList?.keywords?.filter(
    item => !oldKeywordsIds.includes(item._id)
  )

  return !isChangeInCompetitor?.length || !isChangeInKeywords?.length
}
